<template>
  <div>
    <div class="goback-large" style="font-size:17px;">
      <i class="fal fa-arrow-left c-pointer" @click="clickBackButton"></i> 장비 권한에 따른 대시보드 / 토폴로지맵 모니터링 범위
    </div>
    <div style="font-size:13px;">
      <div class="tit">
        WatchAll은 사용자에게 장비별 권한을 부여합니다.
      </div>
      <div class="title-bar">
        할당 받은 장비에 대한 대시보드 및 토폴로지맵의 모니터링 범위는 다음과 같습니다.
      </div>
    </div>
    <el-table-wrapper class="mr-b25" :data="tableData" :columns="tableColumns" :column-default="columnDefault" :pagination="false" style="width:100%;">
    </el-table-wrapper>
    <div style="font-size:13px;">
      <div class="tit">
        대시보드 및 토폴로지맵 이외의 메뉴에서는 권한을 할당 받은 장비에 대한 모니터링이 가능합니다.
      </div>
      <div class="info-text">
        (단, 모니터링 이외의 설정 및 장비 핸들링은 부여 받은 역할에 따라 허용 범위가 다릅니다.)
      </div>
    </div>
  </div>
</template>

<script>
import { columnDefault } from '@/constants/table';

export default {
  name: 'WDeviceAuthInfo',
  data() {
    return {
      columnDefault,
      tableColumns: [
        { prop: 'type', width: 100 },
        { prop: 'admin', label: '어드민', width: 80 },
        { prop: 'manager', label: '관리자' },
        { prop: 'user', label: '사용자' },
      ],
      tableData: [
        { type: '대시보드', admin: 'All', manager: '대시보드 개인화(모니터링 및 편집)', user: '대시보드 개인화(모니터링 및 편집)' },
        { type: '토폴로지맵', admin: 'All', manager: '할당된 장비가 포함된 토폴로지 맵', user: '할당된 장비가 포함된 토폴로지 맵' },
      ],
    };
  },
  methods: {
    clickBackButton() {
      this.$emit('click-back-button');
    },
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/settings/basic/UserAndAuthManagement/UserSettings/components/DeviceAuthInfo.vue